import { OPEN_EDITION_MAX_MINTABLE } from '@soundxyz/utils/constants/constants';

export const isOpenEdition = (quantity: number): boolean => quantity >= OPEN_EDITION_MAX_MINTABLE;
